import _ from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { PermissionService } from "src/services/permissionService/permissionService";
import { SecondaryButton } from "src/ui/shared/CustomButton";

import { useCurrentWorkspace } from "@dashboard/workspaces/api/helpers";
import { useFetchProductBuildsQuery, useFetchProductChangeLogsQuery } from "@products/api";
import { Product } from "@products/types";

import { ChangesDialog } from "./ChangesDialog";

type Props = { product: Product };

export const ChangeSection = (props: Props) => {
    const [isChangesOpen, setIsChangesOpen] = React.useState(false);

    const { data: workspace } = useCurrentWorkspace();
    const { t } = useTranslation(["pages"]);
    const { productAbility } = PermissionService();
    const cannotManageProducts = productAbility(workspace).cannot("manage", "Product");

    const { data: productChanges, isLoading } = useFetchProductChangeLogsQuery(props.product.id);
    const { data: builds = [] } = useFetchProductBuildsQuery(props.product.id);

    const buildsVersions = _.uniq(builds?.map((build) => build.version));
    const versionsObject = _.zipObject(
        buildsVersions,
        buildsVersions.map(() => []),
    );

    return (
        <React.Fragment>
            <SecondaryButton
                data-testid="changes-button"
                onClick={() => setIsChangesOpen(true)}
                size="small"
                disabled={isLoading || cannotManageProducts}
                tooltipProps={{
                    title: t("pages:productPage.tooltip.changesButton"),
                    hide: false,
                }}
            >
                <i className="fa-solid fa-list-ul" style={{ fontSize: 18 }} />
            </SecondaryButton>
            <ChangesDialog
                open={isChangesOpen}
                onClose={() => setIsChangesOpen(false)}
                title="Product releases"
                changes={{ ...versionsObject, ...productChanges }}
                productId={props.product.id}
            />
        </React.Fragment>
    );
};
